module.exports = __webpack_public_path__ + "img/0ff5080.png";